import * as React from 'react';
import Link from '../../components/Link';

interface ICardProps {
    link?: string | string[];
    type?: string;
    img: string | string[];
    title: string;
    description?: string;
}

const renderImgLink = (img: string, link: string | undefined, title: string, description: string | undefined): JSX.Element => {
    return (
        <>
            <Link to={link && typeof link === 'string' ? link : '#'} className="block">
                <img src={img} className="card__img" alt=""/>   
            </Link>

            <Link to={link || '#'} className="card__title block">
                {title}
            </Link>

            {description &&
                <div className="card__description">{description}</div>}
        </>
    );
};

const renderImgGrid = (img: string[], link: string[] | undefined, title: string, description: string | undefined): JSX.Element => {
    return (
        <div className="card__grid">
            {img.map((src: string, i: number) => (
                <React.Fragment key={i}>
                    <Link
                        to={link && link[i] ? link[i] : '#'}
                        target={link && link[i] && link[i] !== '#' ? '_blank' : '_self'}
                    >
                        <img src={src} className="card__img" alt={title} />   
                    </Link>
                </React.Fragment>
            ))}
        </div>);
};

const Card = (props: ICardProps) => {
    const { link, type, img, title, description } = props;
    return (<div className={'card' + (type ? ' card--' + type : '')}>
        {Array.isArray(img) 
            ? (
                <React.Fragment>
                    {renderImgGrid(img, Array.isArray(link) ? link : [link || '#'], title, description)}
                    <div className="card__title block">
                        {title}
                    </div>
                </React.Fragment>
            )
            : renderImgLink(img, Array.isArray(link) ? link[0] : link, title, description)
        }

    </div>
    );
};

export default Card;



// WEBPACK FOOTER //
// ./src/modules/Card/Card.tsx